module.exports = __webpack_public_path__ + "static/media/illustration.189808cf.png";